var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxedPlusOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#000",
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4v4h4v1H8v4H7V9H3V8h4V4h1z",
    fill: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxedPlusOutline);
export default __webpack_public_path__ + "static/media/boxed-plus-outline.b22575aa9a790a248ad955e49fd2019e.svg";
export { ForwardRef as ReactComponent };